<section class="content-section">
  <div class="section-header" style="margin-bottom: 32px;">
    <div>
      <h2 class="page-header__title"><i class="fal fa-box-open"></i> Commandes</h2>
      <p style="color: #6b7280; font-size: 15px;">Gérez toutes les commandes de livraison</p>
    </div>
    <div style="display:flex;gap:10px;align-items:center;flex-wrap:wrap">
      <button class="btn btn-export" (click)="exporterCSV()" title="Exporter en CSV">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="15" height="15">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
        Exporter CSV
      </button>
      <button class="btn btn-primary" [routerLink]="['/commande/enregistrer']" [queryParams]="{ mode: 'urbain' }">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
          <line x1="12" y1="5" x2="12" y2="19"></line>
          <line x1="5" y1="12" x2="19" y2="12"></line>
        </svg>
        Nouvelle commande urbaine
      </button>
    </div>
  </div>

  <div class="filters-card">
    <div class="search-box">
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <input
        type="text"
        class="search-input"
        placeholder="Rechercher une commande (numéro, client, statut...)"
        [(ngModel)]="termeRecherche"
        (ngModelChange)="surChangementRecherche()">
    </div>

    <div class="date-filters">
      <div class="date-filter-group">
        <label class="date-label">Du</label>
        <input type="date" class="date-input" [(ngModel)]="dateDebut" (change)="appliquerFiltres()">
      </div>
      <div class="date-filter-group">
        <label class="date-label">Au</label>
        <input type="date" class="date-input" [(ngModel)]="dateFin" (change)="appliquerFiltres()">
      </div>
      <button *ngIf="dateDebut || dateFin" class="date-reset" (click)="reinitialiserDates()" title="Effacer les dates">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="status-filters">
      <button
        class="status-btn"
        [class.active]="statutSelectionne === 'all'"
        (click)="selectionnerStatut('all')">
        Toutes ({{ compteurToutesListe() }})
      </button>
      <button
        class="status-btn"
        [class.active]="statutSelectionne === 'SANS_LIVREUR'"
        (click)="selectionnerStatut('SANS_LIVREUR')"
        style="background: linear-gradient(135deg, #FEE2E2 0%, #FECACA 100%); border: 1px solid #FCA5A5;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14" style="vertical-align: middle; margin-right: 4px; color: #DC2626;">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="15" y1="9" x2="9" y2="15"></line>
          <line x1="9" y1="9" x2="15" y2="15"></line>
        </svg>
        En attente de livreur ({{ compteurSansLivreurListe() }})
      </button>
      <button
        class="status-btn"
        [class.active]="statutSelectionne === 'AFFECTE'"
        (click)="selectionnerStatut('AFFECTE')">
        Livreur assigné ({{ compteurStatutListe('AFFECTE') }})
      </button>
      <button
        class="status-btn"
        [class.active]="statutSelectionne === 'EN_PREPARATION'"
        (click)="selectionnerStatut('EN_PREPARATION')">
        En route vers le retrait ({{ compteurStatutListe('EN_PREPARATION') }})
      </button>
      <button
        class="status-btn"
        [class.active]="statutSelectionne === 'EN_LIVRAISON'"
        (click)="selectionnerStatut('EN_LIVRAISON')">
        Colis en route ({{ compteurStatutListe('EN_LIVRAISON') }})
      </button>
      <button
        class="status-btn"
        [class.active]="statutSelectionne === 'LIVRE'"
        (click)="selectionnerStatut('LIVRE')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14" style="vertical-align: middle; margin-right: 4px; color: #22C55E;">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
          <polyline points="22 4 12 14.01 9 11.01"></polyline>
        </svg>
        Livrées ({{ compteurStatutListe('LIVRE') }})
      </button>
    </div>
  </div>

  <div *ngIf="indicateurChargement" class="loading-container">
    <div class="spinner"></div>
    <p>Chargement des commandes...</p>
  </div>

  <div *ngIf="!indicateurChargement && commandesFiltrees.length > 0" class="table-card">
    <div class="datatable-controls">
      <div class="entries-control">
        <label>Afficher</label>
        <select [(ngModel)]="taillePage" (ngModelChange)="surChangementTaillePage()" class="page-size-select">
          <option *ngFor="let taille of optionsTaillePage" [value]="taille">{{ taille }}</option>
        </select>
        <label>entrées</label>
      </div>
      <div class="entries-info">
        Affichage de {{ indexDebut }} à {{ indexFin }} sur {{ totalEnregistrements }} entrées
      </div>
    </div>

    <div class="commandes-table-wrapper">
    <table class="commandes-table">
      <thead>
        <tr>
          <th (click)="surTri('numeroCommande')" class="sortable col-numero">
            <div class="th-content">
              <span>N° commande</span>
              <span class="sort-icon" [class.active]="colonneTri === 'numeroCommande'">
                <svg *ngIf="colonneTri === 'numeroCommande' && directionTri === 'asc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
                <svg *ngIf="colonneTri === 'numeroCommande' && directionTri === 'desc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
                <svg *ngIf="colonneTri !== 'numeroCommande'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" opacity="0.3">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
              </span>
            </div>
          </th>
          <th (click)="surTri('clientNom')" class="sortable col-client">
            <div class="th-content">
              <span>Client & livreur</span>
              <span class="sort-icon" [class.active]="colonneTri === 'clientNom'">
                <svg *ngIf="colonneTri === 'clientNom' && directionTri === 'asc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
                <svg *ngIf="colonneTri === 'clientNom' && directionTri === 'desc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
                <svg *ngIf="colonneTri !== 'clientNom'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" opacity="0.3">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
              </span>
            </div>
          </th>
          <th (click)="surTri('statut')" class="sortable col-statut">
            <div class="th-content">
              <span>Statut</span>
              <span class="sort-icon" [class.active]="colonneTri === 'statut'">
                <svg *ngIf="colonneTri === 'statut' && directionTri === 'asc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
                <svg *ngIf="colonneTri === 'statut' && directionTri === 'desc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
                <svg *ngIf="colonneTri !== 'statut'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" opacity="0.3">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
              </span>
            </div>
          </th>
          <th (click)="surTri('dateCreation')" class="sortable col-date">
            <div class="th-content">
              <span>Passée le</span>
              <span class="sort-icon" [class.active]="colonneTri === 'dateCreation'">
                <svg *ngIf="colonneTri === 'dateCreation' && directionTri === 'asc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
                <svg *ngIf="colonneTri === 'dateCreation' && directionTri === 'desc'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
                <svg *ngIf="colonneTri !== 'dateCreation'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" opacity="0.3">
                  <polyline points="18 15 12 9 6 15"></polyline>
                </svg>
              </span>
            </div>
          </th>
          <th class="col-actions" scope="col"><span class="visually-hidden">Actions</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let commande of commandesPaginees; let i = index"
            [class.row-nouvelle-commande]="commande._nouveau && i === 0 && nouvelleCommandeFlash">
          <td class="number-cell">
            <span class="numero-ref">{{ commande.numeroCommande }}</span>
          </td>
          <td class="cell-client">
            <div class="client-principal">{{ commande.clientNom || '—' }}</div>
            <div class="client-livreur" *ngIf="libelleLivreurListe(commande) as liv">{{ liv }}</div>
          </td>
          <td>
            <span
              class="status-badge"
              [ngClass]="obtenirClasseBadgeStatut(commande.statut)">
              {{ obtenirTexteStatut(commande.statut) }}
            </span>
          </td>
          <td class="cell-date">
            {{ datePassage(commande) ? (datePassage(commande) | date:'dd/MM/yy · HH:mm') : '—' }}
          </td>
          <td class="cell-actions">
            <div class="actions-group">
              <button
                type="button"
                class="btn-action btn-action--blue"
                matTooltip="Voir"
                matTooltipPosition="above"
                (click)="voirDetails(commande)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </button>

              <button
                *ngIf="commande.statut !== 'LIVRE' && commande.statut !== 'ANNULE'"
                type="button"
                class="btn-action btn-action--teal"
                matTooltip="Assigner un livreur"
                matTooltipPosition="above"
                (click)="assignerLivreur(commande)"
                [disabled]="estAssignationEnCours(commande.id)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </button>

              <button
                type="button"
                class="btn-action btn-action--orange"
                matTooltip="Signaler un incident"
                matTooltipPosition="above"
                (click)="ouvrirModalIncident(commande); $event.stopPropagation()">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              </button>
              <button
                type="button"
                class="btn-action btn-action--danger"
                matTooltip="Supprimer"
                matTooltipPosition="above"
                (click)="supprimerCommande(commande)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                  <polyline points="3 6 5 6 21 6"></polyline>
                  <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    </div>

    <div class="pagination-container">
      <button
        class="pagination-btn"
        [disabled]="pageCourante === 1"
        (click)="allerALaPage(1)">
        &laquo;
      </button>
      <button
        class="pagination-btn"
        [disabled]="pageCourante === 1"
        (click)="allerALaPage(pageCourante - 1)">
        &lsaquo;
      </button>
      <button
        *ngFor="let page of obtenirNumerosPages()"
        class="pagination-btn"
        [class.active]="page === pageCourante"
        (click)="allerALaPage(page)">
        {{ page }}
      </button>
      <button
        class="pagination-btn"
        [disabled]="pageCourante === totalPages"
        (click)="allerALaPage(pageCourante + 1)">
        &rsaquo;
      </button>
      <button
        class="pagination-btn"
        [disabled]="pageCourante === totalPages"
        (click)="allerALaPage(totalPages)">
        &raquo;
      </button>
    </div>
  </div>

  <div *ngIf="!indicateurChargement && commandesFiltrees.length === 0" class="no-results">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    <h3>Aucune commande trouvée</h3>
    <p>Essayez de modifier vos critères de recherche ou filtres</p>
  </div>


</section>

<!-- ASSIGN SHEET — hors de section pour éviter le stacking context de l'animation opacity -->
<div class="assign-sheet-backdrop" *ngIf="panelAffectationOuvert" (click)="fermerPanelAffectation()"></div>
<aside class="assign-sheet" *ngIf="panelAffectationOuvert" aria-modal="true" role="dialog" aria-labelledby="liste-assign-sheet-title">
  <div class="assign-sheet-header">
    <div>
      <h3 id="liste-assign-sheet-title">Affectation livreur</h3>
      <p class="assign-sheet-lead">
        Commande
        <strong *ngIf="commandeCibleAffectation?.numeroCommande || commandeCibleAffectation?.numeroSuivi">{{ commandeCibleAffectation?.numeroCommande || commandeCibleAffectation?.numeroSuivi }}</strong>
        <span *ngIf="!commandeCibleAffectation?.numeroCommande && !commandeCibleAffectation?.numeroSuivi && commandeCibleAffectation?.id">#{{ commandeCibleAffectation.id }}</span>
      </p>
      <p class="assign-sheet-sub">Choisissez un livreur disponible à proximité.</p>
    </div>
    <button
      type="button"
      class="assign-sheet-close"
      (click)="fermerPanelAffectation()"
      [disabled]="commandeCibleAffectation && assignationEnCoursIds.has(commandeCibleAffectation.id)"
      aria-label="Fermer">✕</button>
  </div>

  <!-- Bloc montant — visible uniquement pour les commandes à tarification particulière -->
  <div class="assign-sheet-contrat-montant" *ngIf="commandeCibleAffectation?.flgTarificationParticuliere">
    <div class="assign-sheet-contrat-badge">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
      Commande sous contrat — tarification particulière
    </div>
    <div class="assign-sheet-contrat-desc" *ngIf="commandeCibleAffectation?.descriptionLibreContrat">
      <span class="assign-sheet-contrat-label">Description client :</span>
      {{ commandeCibleAffectation.descriptionLibreContrat }}
    </div>
    <label class="assign-sheet-contrat-label" for="montantContrat">Montant à facturer (FCFA) <span class="req">*</span></label>
    <input
      id="montantContrat"
      type="number"
      min="0"
      class="form-input"
      placeholder="Ex : 15 000"
      [(ngModel)]="montantContrat">
  </div>

  <div class="assign-sheet-search">
    <input
      type="search"
      class="form-input"
      placeholder="Nom, téléphone ou adresse"
      autocomplete="off"
      [(ngModel)]="rechercheLivreur"
      (ngModelChange)="filtrerLivreursPanel()">
  </div>

  <div class="assign-sheet-body">
    <div class="assign-sheet-loading" *ngIf="chargementLivreurs">
      <div class="spinner"></div>
      <p>Chargement des livreurs...</p>
    </div>

    <div class="assign-sheet-empty" *ngIf="!chargementLivreurs && livreursPanelFiltres.length === 0">
      Aucun livreur ne correspond à cette recherche ou à cette commande.
    </div>

    <div class="assign-sheet-grid" *ngIf="!chargementLivreurs && livreursPanelFiltres.length > 0">
      <article class="assign-sheet-card" *ngFor="let livreur of livreursPanelFiltres">
        <div class="assign-sheet-card-head">
          <h4>{{ livreur.nom }} {{ livreur.prenom }}</h4>
          <span class="tag-dispo">Disponible</span>
        </div>
        <p>📱 {{ livreur.contact || '—' }}</p>
        <p>📍 {{ livreur.adresse || 'Adresse non renseignée' }}</p>
        <p>📦 {{ livreur.nombreCommandesEnCours || 0 }} course(s) en cours</p>
        <p *ngIf="livreur.vehiculeActuel">
          <span *ngIf="libelleTypeVehicule(livreur) as tv">{{ tv }} — </span>{{ livreur.vehiculeActuel.marque }} {{ livreur.vehiculeActuel.modele }}
          <span class="tag-immat">{{ livreur.vehiculeActuel.immatriculation }}</span>
        </p>
        <p *ngIf="!livreur.vehiculeActuel" style="color:#9ca3af; font-style:italic;">Véhicule non renseigné</p>
        <button
          type="button"
          class="btn btn-primary assign-sheet-cta"
          [disabled]="commandeCibleAffectation && assignationEnCoursIds.has(commandeCibleAffectation.id)"
          (click)="assignerLivreurDepuisPanel(livreur)">
          Assigner ce livreur
        </button>
      </article>
    </div>
  </div>
</aside>

<!-- MODAL INCIDENT -->
<div class="modal-backdrop" *ngIf="modalIncidentOuvert" (click)="fermerModalIncident()">
  <div class="modal-card" (click)="$event.stopPropagation()">

    <!-- En-tête -->
    <div class="modal-header">
      <div class="modal-header__left">
        <div class="modal-header__icon">
          <i class="fal fa-exclamation-triangle"></i>
        </div>
        <div>
          <h3>Signaler un incident</h3>
          <p class="modal-header__sub" *ngIf="commandeIncident">
            <i class="fal fa-box-open"></i> {{ commandeIncident.numeroCommande }}
          </p>
        </div>
      </div>
      <button class="modal-close" (click)="fermerModalIncident()"><i class="fal fa-times"></i></button>
    </div>

    <!-- Corps -->
    <div class="modal-body">

      <!-- Type d'incident -->
      <div class="modal-field">
        <p class="modal-label">Type d'incident <span class="modal-required">*</span></p>
        <div class="modal-type-grid">
          <button type="button" class="modal-type-btn"
                  [class.modal-type-btn--active]="incidentForm.type === 'PRODUIT_ENDOMMAGE'"
                  (click)="incidentForm.type = 'PRODUIT_ENDOMMAGE'">
            <i class="fal fa-box-fragile"></i><span>Colis endommagé</span>
          </button>
          <button type="button" class="modal-type-btn"
                  [class.modal-type-btn--active]="incidentForm.type === 'PERTE'"
                  (click)="incidentForm.type = 'PERTE'">
            <i class="fal fa-question-circle"></i><span>Colis perdu</span>
          </button>
          <button type="button" class="modal-type-btn"
                  [class.modal-type-btn--active]="incidentForm.type === 'VOL'"
                  (click)="incidentForm.type = 'VOL'">
            <i class="fal fa-user-secret"></i><span>Vol</span>
          </button>
          <button type="button" class="modal-type-btn"
                  [class.modal-type-btn--active]="incidentForm.type === 'RETARD_LIVRAISON'"
                  (click)="incidentForm.type = 'RETARD_LIVRAISON'">
            <i class="fal fa-clock"></i><span>Retard</span>
          </button>
          <button type="button" class="modal-type-btn"
                  [class.modal-type-btn--active]="incidentForm.type === 'ERREUR_COMMANDE'"
                  (click)="incidentForm.type = 'ERREUR_COMMANDE'">
            <i class="fal fa-exclamation-triangle"></i><span>Erreur commande</span>
          </button>
          <button type="button" class="modal-type-btn"
                  [class.modal-type-btn--active]="incidentForm.type === 'AUTRE'"
                  (click)="incidentForm.type = 'AUTRE'">
            <i class="fal fa-ellipsis-h"></i><span>Autre</span>
          </button>
        </div>
      </div>

      <!-- Description -->
      <div class="modal-field">
        <p class="modal-label">Description <span class="modal-optional">(optionnel)</span></p>
        <textarea class="modal-input" rows="3"
                  [(ngModel)]="incidentForm.description"
                  placeholder="Décrivez l'incident en quelques mots..."></textarea>
      </div>

    </div>

    <!-- Pied -->
    <div class="modal-footer">
      <button class="btn-modal-cancel" (click)="fermerModalIncident()">
        <i class="fal fa-times"></i> Annuler
      </button>
      <button class="btn-modal-danger"
              [disabled]="!incidentForm.type || enregistrementIncident"
              (click)="soumettreIncident()">
        <i class="fal"
           [class.fa-exclamation-triangle]="!enregistrementIncident"
           [class.fa-spinner]="enregistrementIncident"
           [class.fa-spin]="enregistrementIncident"></i>
        {{ enregistrementIncident ? 'Envoi en cours…' : 'Signaler l\'incident' }}
      </button>
    </div>

  </div>
</div>
